import styled from 'styled-components';

import { Colors } from '@rockalingua/ui';
import { variantStyles as textVariantStyles } from '@rockalingua/ui/components/Typography/Text.styled';

export const PlansSection = styled.div`
  display: flex;
  gap: 24px;

  > * {
    flex: 1;
  }
`;

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const PlanHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`;

export const PlanName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PlanTitle = styled.div`
  ${textVariantStyles['grey-22-bold']}
  color: ${Colors.MAIN_VARIANTS[60]};
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const PriceAmount = styled.div`
  ${textVariantStyles['title-small-grey-22']}
  color: ${Colors.BLACK};
`;

export const PriceLabel = styled.div`
  ${textVariantStyles['grey-14-bold']}
  color: ${Colors.BLACK};
`;

export const PlanSubtitle = styled.div`
  ${textVariantStyles['grey-16-medium']}
  color: ${Colors.BLACK};
`;

export const ButtonGroupContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonGroup = styled.div`
  width: min(400px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FeaturesTitle = styled.div`
  ${textVariantStyles['cardTitle']}
  color: ${Colors.BLACK};
`;

export const FeatureItem = styled.div`
  ${textVariantStyles['dm-14-medium']}
  color: ${Colors.BLACK};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
`;
